<template>
<el-pagination background :layout="lay"  :total="count" :current-page="value" :page-size="limit" @current-change="on.page"></el-pagination>
</template>

<script>
export default {
	props:{
		value:{default(){return 1}},
		count:{default(){return 0}},
		limit:{default(){return 10}},
		lay:{default(){return 'total, prev, pager, next, jumper'}}
	},
	data(){
		var vue = this;

		return {
			on:{
				page(d){
					vue.$emit('input',d);
					vue.$emit('change',d);
				}
			}
		}
	}
}
</script>	